var map = {
	"./AK_10_kafle_desktop.jpg": 39421,
	"./AK_10_kafle_mobile.jpg": 53736,
	"./AK_11_kafle_desktop.jpg": 15620,
	"./AK_11_kafle_mobile.jpg": 9039,
	"./AK_12_kafle_desktop.jpg": 61147,
	"./AK_12_kafle_mobile.jpg": 17788,
	"./AK_13_kafle_desktop.jpg": 37477,
	"./AK_13_kafle_mobile.jpg": 49218,
	"./AK_14_kafle_desktop.jpg": 56047,
	"./AK_14_kafle_mobile.jpg": 55740,
	"./AK_15_kafle_desktop.jpg": 63852,
	"./AK_15_kafle_mobile.jpg": 57890,
	"./AK_16_kafle_desktop.jpg": 39367,
	"./AK_16_kafle_mobile.jpg": 65729,
	"./AK_17_kafle_desktop.jpg": 99118,
	"./AK_17_kafle_mobile.jpg": 69599,
	"./AK_18_kafle_desktop.jpg": 98733,
	"./AK_18_kafle_mobile.jpg": 98297,
	"./AK_19_kafle_desktop.jpg": 40322,
	"./AK_19_kafle_mobile.jpg": 98173,
	"./AK_1_kafle_desktop.jpg": 98586,
	"./AK_1_kafle_mobile.jpg": 72639,
	"./AK_20_kafle_desktop.jpg": 59255,
	"./AK_20_kafle_mobile.jpg": 83379,
	"./AK_21_kafle_desktop.jpg": 97603,
	"./AK_21_kafle_mobile.jpg": 2280,
	"./AK_22_kafle_desktop.jpg": 416,
	"./AK_22_kafle_mobile.jpg": 85209,
	"./AK_23_kafle mobile.jpg": 44791,
	"./AK_23_kafle_desktop.jpg": 46234,
	"./AK_24_kafle_desktop.jpg": 41917,
	"./AK_24_kafle_mobile.jpg": 63906,
	"./AK_2_kafle_desktop.jpg": 26915,
	"./AK_2_kafle_mobile.jpg": 66544,
	"./AK_30_kafle_desktop.jpg": 84838,
	"./AK_30_kafle_mobile.jpg": 6153,
	"./AK_3_kafle_desktop.jpg": 27471,
	"./AK_3_kafle_mobile.jpg": 61846,
	"./AK_4_kafle_desktop.jpg": 75633,
	"./AK_4_kafle_mobile.jpg.jpg": 77285,
	"./AK_5_kafle_desktop.jpg": 81047,
	"./AK_5_kafle_mobile.jpg": 6824,
	"./AK_6_kafle_desktop.jpg": 27022,
	"./AK_6_kafle_mobile.jpg": 59764,
	"./AK_7_kafle_desktop.jpg": 66453,
	"./AK_7_kafle_mobile.jpg": 86615,
	"./AK_8_kafle_desktop.jpg": 65962,
	"./AK_8_kafle_mobile.jpg": 97847,
	"./AK_9_kafle_desktop.jpg": 71008,
	"./AK_9_kafle_mobile.jpg": 74680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80700;